import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import MyLeaveList from "./myLeaveList";
import MyLeaveList2 from "./myLeaveList2";

const LeaveList = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="Leave List" />

      <div className="">
        <div className="container">
          <section className="top-space pt-0 pb-0">
            {context.settingValue("leave_with_substitute_approval") == 1 ? (
              <MyLeaveList2 titleText={"Leave List"} />
            ) : (
              <MyLeaveList titleText={"Leave List"} />
            )}
          </section>
          <section className="top-space "></section>
        </div>
      </div>
    </>
  );
};
export default LeaveList;
